import { createContext, useContext, useState } from "react";
import type { ReactNode, Dispatch, SetStateAction } from "react";
import type { Deal } from "../types/deal";

// export type DealType = {
//   id: number;
//   Deal: any;
// };

interface DealsContextType {
  deals: Deal[];
  initialDeals: Deal[];
  setDeals: (value: Deal[] | ((prev: Deal[]) => Deal[])) => void;
  setInitialDeals: (value: Deal[] | ((prev: Deal[]) => Deal[])) => void;
  dirtyGrid: boolean;
  setDirtyGrid: Dispatch<SetStateAction<boolean>>;
}

const DealsContext = createContext<DealsContextType | undefined>(undefined);

export const DealsProvider = ({ children }: { children: ReactNode }) => {
  const [deals, setDealsState] = useState<Deal[]>([]);
  const [initialDeals, setInitialDealsState] = useState<Deal[]>([]);
  const [dirtyGrid, setDirtyGrid] = useState<boolean>(false);

  // Create wrapper functions that handle both direct values and functions
  const setDeals = (value: Deal[] | ((prev: Deal[]) => Deal[])) => {
    if (typeof value === "function") {
      setDealsState(value);
    } else {
      setDealsState(value);
    }
  };

  const setInitialDeals = (value: Deal[] | ((prev: Deal[]) => Deal[])) => {
    if (typeof value === "function") {
      setInitialDealsState(value);
    } else {
      setInitialDealsState(value);
    }
  };

  return (
    <DealsContext.Provider
      value={{
        deals,
        initialDeals,
        dirtyGrid,
        setDeals,
        setInitialDeals,
        setDirtyGrid,
      }}
    >
      {children}
    </DealsContext.Provider>
  );
};

export const useDealsProvider = () => {
  const context = useContext(DealsContext);
  if (!context) {
    throw new Error("useDealsProvider must be used within a DealsProvider");
  }
  return context;
};
